import { cn } from "@/utils/cn";
import React from "react";

const variantStyles = {
  default: "bg-gray-100 text-gray-900 hover:bg-gray-200",
  primary: "bg-blue-100 text-blue-900 hover:bg-blue-200",
  secondary: "bg-purple-100 text-purple-900 hover:bg-purple-200",
  success: "bg-green-100 text-green-900 hover:bg-green-200",
  warning: "bg-yellow-100 text-yellow-900 hover:bg-yellow-200",
  danger: "bg-red-100 text-red-900 hover:bg-red-200",
  outline: "border border-gray-200 text-gray-900 hover:bg-gray-100",
};

const sizeStyles = {
  sm: "px-2 py-0.5 text-xs",
  md: "px-2.5 py-0.5 text-sm",
  lg: "px-3 py-1 text-base",
};

export const Badge = React.forwardRef(
  (
    {
      className,
      variant = "default",
      size = "md",
      children,
      onClick,
      ...props
    },
    ref
  ) => {
    return (
      <span
        ref={ref}
        className={cn(
          "inline-flex items-center justify-center font-medium rounded-full transition-colors",
          variantStyles[variant],
          sizeStyles[size],
          onClick && "cursor-pointer",
          className
        )}
        onClick={onClick}
        {...props}
      >
        {children}
      </span>
    );
  }
);

Badge.displayName = "Badge";
